import { EmployeeFromSchedule } from '@/types';

export const updateShiftsByDate = (loanedEmployee: EmployeeFromSchedule) =>
  loanedEmployee.shifts.reduce((acc, shift) => {
    const { date, id } = shift;
    const updatedShifts = [...(acc[date] || []), id];
    return { ...acc, [date]: updatedShifts };
  }, {});
